import { z } from "zod";

export const MaquinaEquipArquivoSchema = z
  .object({
    descricao: z.string().nonempty("Este campo deve ser preenchido."),
    arquivo: z.instanceof(File).nullable().default(null),
    limparArquivo: z.coerce.boolean().default(false),
  })
  .superRefine((data, ctx) => {
    if (data.arquivo === null) {
      if (data.limparArquivo === true) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Você deve fornecer um arquivo.",
          path: ["arquivo"],
        });
      }
    }
  });

export type MaquinaEquipArquivoForm = z.infer<typeof MaquinaEquipArquivoSchema>;
